import {Badge, Button, ButtonGroup, CardActions, CardHeader, Divider, FormControlLabel, Grid2} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import Card from "@mui/material/Card";
import {Link, useNavigate} from "react-router-dom";
import AuthContext from "../Services/AuthContext";
import {Add, Delete, Edit, Event, Key} from "@mui/icons-material";
import Switch from '@mui/material/Switch';
import Main from "../Layout/Main";
import AddSeason from "../Panel/Season/AddSeason";
import EditSeason from "../Panel/Season/EditSeason";

function Season() {
    const [user] = useContext(AuthContext);
    const [items, setItems] = useState([]);
    const [refresh, setRefresh] = useState(0);

    const [addSeason, setAddSeason] = useState(false);
    const [editSeason, setEditSeason] = useState(false);
    const [archived, setArchived] = useState(false);
    const [cards, setCards] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        if (user.token === "") {
            navigate("/");
        }
    }, [user.token, navigate]);

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchData() {
            await fetch(`/api/season`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setItems(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [user, refresh]);

    function _delete(id) {
        fetch(`/api/season/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(() => {
                setRefresh(r => ++r);
            })
            .catch(err => {
                console.log(err)
            })
    }

    useEffect(() => {
        setCards(items.filter((it) => {return archived || it.all_camps === 0 || it.active_camps}).map((item) => <Grid2 item size={12} key={item.id}>
            <Card>
                <CardHeader title={item.name} subheader={item.organization} action={<>
                    <Button variant={'text'} color={'success'}>Uczestnicy: {item.registered} / {item.max_participants}</Button>
                    <Button variant={'text'} color={'warning'}>Rezerwowi: {item.reserved}</Button>
                </>}
                />
                {item.quota && <Button variant={'text'} color={'error'}>Blokada: {item.quota} dni / os</Button>}
                <Divider/>

                <CardActions sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}>
                    <ButtonGroup>
                        <Badge badgeContent={item.active_camps} color={'info'}><Link
                            to={`/season/${item.id}`}><Button
                            variant={'outlined'} color={'info'} startIcon={<Event />}>Wydarzenia</Button></Link></Badge>
                        <Button disabled={!item.can_edit} onClick={() => setEditSeason(item)}
                                variant={'outlined'} color={'success'} startIcon={<Edit />}>Edytuj</Button>
                        <Link to={!item.can_edit ? '/season' : `/season/${item.id}/priority`}>
                            <Button disabled={!item.can_edit} variant={'outlined'} color={'warning'} startIcon={<Key />}>Priorytet: {item.restrictions}</Button>
                        </Link>
                        <Button disabled={!item.can_edit}
                                variant={'outlined'} color={'error'} startIcon={<Delete />} onDoubleClick={() => _delete(item.id)}>Usuń</Button>
                    </ButtonGroup>
                </CardActions>
            </Card>
        </Grid2>));
    }, [archived, items]);

    return (<Main title={'Sezony'} actions={<>
        <FormControlLabel control={<Switch onChange={() => setArchived(a => !a)} checked={archived} />} label="Przeszłe" />
        {user.isAnyAdmin && <Button variant={'contained'} onClick={() => setAddSeason(true)} startIcon={<Add />}>Dodaj Sezon</Button>}
    </>}>
        <Grid2 container spacing={4} justifyContent={'space-between'} flexWrap={'wrap'} sx={{width: '95vw', maxWidth: '1200px'}}>
            {cards}
        </Grid2>
        <AddSeason isOpen={addSeason} dismiss={() => setAddSeason(false)} onSuccess={() => setRefresh(r => ++r)} />
        <EditSeason data={editSeason} dismiss={() => setEditSeason(false)} onSuccess={() => setRefresh(r => ++r)} />
    </Main>);
}

export default Season;